// expansion panel style CheckoutCard
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  margin-bottom: -36px !important;\n  & .summaryHider {\n    display: flex;\n    width: 100%;\n    opacity: 1;\n    transition-property: opacity;\n    transition-duration: 300ms;\n  }\n  &.Mui-expanded .summaryHider {\n    opacity: 0;\n  }\n\n  &.Mui-focused {\n    background-color: transparent !important;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  opacity: 0;\n  position: relative;\n  transition-property: opacity;\n  transition-duration: 300ms;\n  &.expanded {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  align-items: flex-start;\n  appearance: none;\n  background-color: transparent;\n  border: none;\n  color: #848f97;\n  cursor: pointer;\n  display: flex;\n  font-size: 13px;\n  font-family: ",
        ";\n  margin: 0 0 0 auto;\n  padding: 0;\n  user-select: none;\n  z-index: 2;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  color: #848f97;\n  text-decoration: underline;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  align-self: flex-start;\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import Button from './button';
import { Accordion, AccordionSummary, AccordionActions } from './accordion';
export var CheckoutAccordionContext = /*#__PURE__*/ React.createContext();
export function CheckoutAccordion(props) {
    var onChange = props.onChange, expanded = props.expanded;
    var _props_defaultCancel = props.defaultCancel, defaultCancel = _props_defaultCancel === void 0 ? true : _props_defaultCancel, _props_defaultButton = props.defaultButton, defaultButton = _props_defaultButton === void 0 ? true : _props_defaultButton, _props_hideToggles = props.hideToggles, hideToggles = _props_hideToggles === void 0 ? false : _props_hideToggles, onCancel = props.onCancel, onSave = props.onSave, expandText = props.expandText, cancelText = props.cancelText, onExpand = props.onExpand, _props_crossfade = props.crossfade, crossfade = _props_crossfade === void 0 ? false : _props_crossfade, _props_dataCyName = props.dataCyName, dataCyName = _props_dataCyName === void 0 ? 'unknown' : _props_dataCyName, other = _object_without_properties(props, [
        "defaultCancel",
        "defaultButton",
        "hideToggles",
        "onCancel",
        "onSave",
        "expandText",
        "cancelText",
        "onExpand",
        "crossfade",
        "dataCyName"
    ]);
    var contextValue = useMemo(function() {
        return {
            defaultCancel: defaultCancel,
            defaultButton: defaultButton,
            hideToggles: hideToggles,
            onChange: onChange,
            onCancel: onCancel,
            onSave: onSave,
            expanded: expanded,
            expandText: expandText,
            cancelText: cancelText,
            onExpand: onExpand,
            crossfade: crossfade,
            dataCyName: dataCyName
        };
    }, [
        crossfade,
        dataCyName,
        defaultCancel,
        defaultButton,
        hideToggles,
        onChange,
        onCancel,
        onSave,
        expanded,
        expandText,
        cancelText,
        onExpand
    ]);
    return /*#__PURE__*/ _jsx(CheckoutAccordionContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ _jsx(Accordion, _object_spread({}, other))
    });
}
export function CheckoutAccordionSummary(props) {
    var children = props.children, other = _object_without_properties(props, [
        "children"
    ]);
    var _useContext = useContext(CheckoutAccordionContext), defaultCancel = _useContext.defaultCancel, hideToggles = _useContext.hideToggles, onCancel = _useContext.onCancel, onChange = _useContext.onChange, expanded = _useContext.expanded, _useContext_expandText = _useContext.expandText, expandText = _useContext_expandText === void 0 ? 'Change' : _useContext_expandText, _useContext_cancelText = _useContext.cancelText, cancelText = _useContext_cancelText === void 0 ? 'Cancel' : _useContext_cancelText, onExpand = _useContext.onExpand, crossfade = _useContext.crossfade, dataCyName = _useContext.dataCyName;
    function handleCancel(e) {
        e.stopPropagation();
        if (onCancel) {
            onCancel();
        } else if (onChange) {
            onChange();
        }
    }
    function handleExpand() {
        if (onExpand) {
            onExpand();
        }
    }
    if (crossfade) {
        return /*#__PURE__*/ _jsxs(CrossfadeSummary, _object_spread_props(_object_spread({
            tabIndex: -1
        }, other), {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "summaryHider",
                    children: children
                }),
                !hideToggles && defaultCancel && expanded && /*#__PURE__*/ _jsx(CancelButton, {
                    "data-cy": "expanded-cancel-".concat(dataCyName),
                    "data-test": "expanded-cancel-".concat(dataCyName),
                    "data-testid": "expanded-cancel-".concat(dataCyName),
                    onClick: handleCancel,
                    children: cancelText
                }),
                !hideToggles && onExpand && !expanded && /*#__PURE__*/ _jsx(ExpandText, {
                    "data-cy": "expand-text-".concat(dataCyName),
                    "data-test": "expand-text-".concat(dataCyName),
                    "data-testid": "expand-text-".concat(dataCyName),
                    onClick: handleExpand,
                    children: expandText
                })
            ]
        }));
    }
    return /*#__PURE__*/ _jsxs(StyledAccordionSummary, _object_spread_props(_object_spread({
        tabIndex: -1
    }, other), {
        children: [
            children,
            !hideToggles && defaultCancel && expanded && /*#__PURE__*/ _jsx(CancelButton, {
                onClick: handleCancel,
                children: cancelText
            }),
            !hideToggles && onExpand && !expanded && /*#__PURE__*/ _jsx(ExpandText, {
                "data-cy": "expand-text-".concat(dataCyName),
                "data-test": "expand-text-".concat(dataCyName),
                "data-testid": "expand-text-".concat(dataCyName),
                onClick: handleExpand,
                children: expandText
            })
        ]
    }));
}
export function CheckoutAccordionActions(props) {
    var children = props.children, _props_className = props.className, className = _props_className === void 0 ? '' : _props_className, other = _object_without_properties(props, [
        "children",
        "className"
    ]);
    var _useContext = useContext(CheckoutAccordionContext), defaultButton = _useContext.defaultButton, onSave = _useContext.onSave, crossfade = _useContext.crossfade, expanded = _useContext.expanded, dataCyName = _useContext.dataCyName;
    function renderContents() {
        return /*#__PURE__*/ _jsxs(Grid, {
            container: true,
            children: [
                /*#__PURE__*/ _jsx(Grid, {
                    "data-cy": "expand-details-".concat(dataCyName),
                    "data-test": "expand-details-".concat(dataCyName),
                    "data-testid": "expand-details-".concat(dataCyName),
                    item: true,
                    xs: 12,
                    children: children
                }),
                /*#__PURE__*/ _jsx(Grid, {
                    item: true,
                    xs: 12,
                    children: defaultButton && /*#__PURE__*/ _jsx(StyledButton, {
                        width: "73px",
                        height: "33px",
                        onClick: onSave,
                        "data-cy": "checkout-expansion-save-".concat(dataCyName),
                        "data-test": "checkout-expansion-save-".concat(dataCyName),
                        "data-testid": "checkout-expansion-save-".concat(dataCyName),
                        children: "Save"
                    })
                })
            ]
        });
    }
    if (crossfade) {
        return /*#__PURE__*/ _jsx(CrossfadeDetails, _object_spread_props(_object_spread({
            className: "".concat(className, " ").concat(expanded ? 'expanded' : '')
        }, other), {
            children: renderContents()
        }));
    }
    return /*#__PURE__*/ _jsx(AccordionActions, _object_spread_props(_object_spread({}, other), {
        children: renderContents()
    }));
}
CheckoutAccordion.testProps = [
    {
        children: [
            /*#__PURE__*/ _jsx(CheckoutAccordionSummary, {
                children: "Summary"
            }),
            /*#__PURE__*/ _jsx(CheckoutAccordionActions, {
                children: "Details"
            })
        ]
    },
    {
        children: [
            /*#__PURE__*/ _jsx(CheckoutAccordionSummary, {
                children: "Summary"
            }),
            /*#__PURE__*/ _jsx(CheckoutAccordionActions, {
                children: "Details"
            })
        ],
        expanded: true
    }
];
CheckoutAccordionSummary.snapshot = false;
CheckoutAccordionActions.snapshot = false;
var StyledAccordionSummary = styled(AccordionSummary)(_templateObject());
var CrossfadeSummary = styled(AccordionSummary)(_templateObject1());
var CrossfadeDetails = styled(AccordionActions)(_templateObject2());
var CancelButton = styled.button(_templateObject3(), function(param) {
    var theme = param.theme;
    var _theme_customized_fonts, _theme_customized;
    return theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_fonts = _theme_customized.fonts) === null || _theme_customized_fonts === void 0 ? void 0 : _theme_customized_fonts.primary;
});
export var ExpandText = styled(CancelButton)(_templateObject4());
export var StyledButton = styled(Button)(_templateObject5());
